import { api, apiUrl } from "../../../shared/services/service";
import type { HullPaintsDashboardResponse } from "../models/hull-paints.models";
import axios from "axios";

export const getHullPaintsDashboard = async (signal?: AbortSignal): Promise<HullPaintsDashboardResponse> => {
  const response = await api.get<HullPaintsDashboardResponse>(`${apiUrl}/pbi/hull-paints`, { signal });

  return response.data;
};

export const getHullPaintsErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const response = error.response?.data as { error?: string; message?: string } | undefined;

    return response?.error ?? response?.message ?? error.message;
  }

  return error instanceof Error ? error.message : "Hull Paints data could not be loaded.";
};
